class KorveyColourSiblings {
  constructor(container) {
    this.container = container;

    this.productTitle =
      container.dataset.productTitle.trim();

    this.productHandle =
      container.dataset.productHandle;

    this.productUrl =
      container.dataset.productUrl;

    this.currentColourElement =
      container.querySelector(
        '#KorveyCurrentColour'
      );

    this.list =
      container.querySelector(
        '#KorveyColourSiblings'
      );

    this.colours =
      window.KorveyColourConfig?.colours || [];

    this.init();
  }


  init() {
    const currentProduct =
      this.getProductData(
        this.productTitle
      );

    if (!currentProduct) {
      this.hide();
      return;
    }

    this.baseName =
      currentProduct.baseName;

    this.currentColour =
      currentProduct.colour;

    this.currentColourElement.textContent =
      this.currentColour;

    this.searchProducts();
  }


  getProductData(title) {
    const normalizedTitle =
      title.trim().toUpperCase();

    const sortedColours =
      [...this.colours].sort(
        (a, b) => b.length - a.length
      );

    for (const colour of sortedColours) {
      const normalizedColour =
        colour.toUpperCase();

      if (
        normalizedTitle.endsWith(
          ` ${normalizedColour}`
        )
      ) {
        return {
          baseName: normalizedTitle
            .slice(
              0,
              normalizedTitle.length -
                normalizedColour.length
            )
            .trim(),

          colour: normalizedColour
        };
      }
    }

    return null;
  }


  async searchProducts() {
    try {
      const params =
        new URLSearchParams();

      params.set(
        'q',
        this.baseName
      );

      params.set(
        'type',
        'product'
      );

      params.set(
        'options[prefix]',
        'last'
      );

      const response =
        await fetch(
          `${window.Shopify.routes.root}search/suggest.json?${params.toString()}`
        );

      if (!response.ok) {
        throw new Error(
          'Unable to search products'
        );
      }

      const data =
        await response.json();

      const products =
        data.resources?.results?.products || [];

      const siblings =
        products
          .map((product) => {
            const productData =
              this.getProductData(
                product.title
              );

            if (!productData) {
              return null;
            }

            if (
              productData.baseName !==
              this.baseName
            ) {
              return null;
            }

            return {
              ...product,
              colour:
                productData.colour
            };
          })
          .filter(Boolean);

      const currentExists =
        siblings.some(
          (product) =>
            product.handle ===
            this.productHandle
        );

      /*
       * Shopify Predictive Search
       * may not always return
       * the current product.
       */

      if (!currentExists) {
        siblings.unshift({
          title: this.productTitle,
          handle: this.productHandle,
          url: this.productUrl,
          colour: this.currentColour,
          featured_image: null
        });
      }

      if (siblings.length < 2) {
        this.hide();
        return;
      }

      this.render(siblings);

    } catch (error) {
      console.error(
        'KORVÉY Colour Siblings Error:',
        error
      );

      this.hide();
    }
  }


  render(products) {
    this.list.innerHTML = '';

    const uniqueProducts =
      products.filter(
        (product, index, array) =>
          index ===
          array.findIndex(
            (item) =>
              item.handle ===
              product.handle
          )
      );

    uniqueProducts.forEach(
      (product) => {

        const isActive =
          product.handle ===
          this.productHandle;

        const link =
          document.createElement('a');

        link.href =
          product.url;

        link.className =
          `korvey-colour-swatch ${
            isActive
              ? 'is-active'
              : ''
          }`;

        link.setAttribute(
          'aria-label',
          `Colour: ${product.colour}`
        );

        if (isActive) {
          link.setAttribute(
            'aria-current',
            'true'
          );
        }


        const inner =
          document.createElement('span');

        inner.className =
          'korvey-colour-swatch__inner';


        const imageUrl =
          product.featured_image?.url ||
          product.image ||
          product.featured_media?.preview_image?.url;


        if (imageUrl) {
          const image =
            document.createElement('img');

          image.src =
            imageUrl;

          image.alt =
            product.colour;

          image.loading =
            'lazy';

          inner.appendChild(
            image
          );

        } else {

          inner.style.background =
            this.getColourFallback(
              product.colour
            );

        }


        const name =
          document.createElement('span');

        name.className =
          'korvey-colour-swatch__name';

        name.textContent =
          product.colour;


        link.appendChild(inner);

        link.appendChild(name);

        this.list.appendChild(
          link
        );

      }
    );
  }


  getColourFallback(colour) {
    const colourMap = {

      BLACK: '#000000',
      WHITE: '#ffffff',
      CREAM: '#f2ede3',
      ESPRESSO: '#4b3025',
      CRIMSON: '#b00f2f',
      BROWN: '#704214',
      CHOCOLATE: '#5a3825',
      NAVY: '#1c2b45',
      BLUE: '#4d6d9a',
      GREEN: '#66745f',
      OLIVE: '#70754b',
      GREY: '#888888',
      CHARCOAL: '#333333',
      BEIGE: '#d8c8b8',
      RED: '#c51e32',
      PINK: '#d89ca7',
      PURPLE: '#76617a',
      ORANGE: '#d77a35',
      YELLOW: '#d9bd4e'

    };

    return (
      colourMap[colour] ||
      '#ededed'
    );
  }


  hide() {
    this.container.classList.add(
      'is-hidden'
    );
  }
}


document.addEventListener(
  'DOMContentLoaded',
  () => {

    document
      .querySelectorAll(
        '.korvey-color-siblings'
      )
      .forEach(
        (container) => {

          new KorveyColourSiblings(
            container
          );

        }
      );

  }
);